module.exports = __webpack_public_path__ + "img/logo-doc.439fef87.webp";